define('CustomHome'
,   [
		'Utils'
	,	'Home.View'
	,	'underscore'
	]
,   function (
		Utils
	,	HomeView
	,	_
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			// using the 'Layout' component we add a new child view inside the 'Header' existing view 
			// (there will be a DOM element with the HTML attribute data-view="Header.Logo")
			// more documentation of the Extensibility API in
			// https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html
			
			/** @type {LayoutComponent} */
			var layout = container.getComponent('Layout');
			
			if(layout)
			{
				var Configuration = container.getConfig();
				layout.addToViewContextDefinition('Home.View', 'carouselImages', 'array', function(context) {
					var carouselImages = _.map(Configuration.get('home.carouselImages', []), function(carousel){
						return {
							src: Utils.getAbsoluteUrlOfNonManagedResources(carousel['src'])
						,	href: carousel['href']
						};
					})
					return carouselImages || context['carouselImages'];
				});
				layout.addToViewContextDefinition('Home.View', 'bottomBannerImages', 'array', function(context) {
					var bottomBannerImages = _.map(Configuration.get('home.bottomBannerImages', []), function(banner){
						return {
							src: Utils.getAbsoluteUrlOfNonManagedResources(banner['src'])
						,	href: banner['href']
						,	text: banner['text']
						};
					})
					return bottomBannerImages || context['bottomBannerImages'];
				});

				HomeView.prototype.initSlider = _.wrap(HomeView.prototype.initSlider, function(fn){
					Utils.initBxSlider(this.$("[data-slider]"), {
						controls: false,
						auto: true,
						infiniteLoop: true
					});
				});
			}

		}
	};
});
